import { useGetPlumaQuery } from 'services/api/Meteorology/Weather/Area/Status';

export default function usePluma(area: string) {
  const { data, error, isLoading } = useGetPlumaQuery({ area });

  return { data, isLoading, error };
}
